import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/pbatch_run/variant_solo/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'S', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 30, type: 'status'},
        // {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'N', value: 'notion_id', sortable: false, filterable: true, divider: false, width: 10},
        {text: 'Title', value: 'title', sortable: true, filterable: true, divider: true, width: 600},
        {text: 'status', value: 'status', sortable: true, filterable: true, divider: true, type: 'date', width: 200},
        // {text: 'customer__title', value: 'customer__title', sortable: true, filterable: true, divider: true, width: 400},
        // {text: 'customer_number', value: 'customer_number', sortable: true, filterable: true, divider: true, width: 60},
        // {text: 'version_name', value: 'version_name', sortable: true, filterable: true, divider: true, width: 200},
        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['title'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: false,
    },
    filterGroupSingle: [],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        PVariantSoloTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}